<template>
<!-- Much of this could be moved to a separate component but it could be premature optimization for the moment.
     Perhaps if more providers offer installation options we can tease out some commonalities and come up with
     an abstraction specific to XMission and make a component for it. But for now, this is fine.
-->
  <div>
    <text-overlay :show="querying_api" :text="overlay_text" no-wrap fixed/>
    <div>
      <div v-if="dropDetails.needs_ont_install">
        <br/>
        <!-- Installation notes and install type select -->
        <div>
          <div >
            <div>
              <h5>Fiber installation: home exterior <small >(red pin <span class="red-pin-icon"></span> shows where the fiber will attach to your home, typically near other utilities). The red pin marks the pre-engineered fiber location where Lehi City plans to reach your home. Note that adjusting this location will trigger an engineering review, potentially leading to extra charges and installation delays.</small></h5>

            </div>
            <google-maps-draggable :draggable="true" v-model="location_details"></google-maps-draggable>
            <br/>
          </div>
          <div>
            <h5>Exterior installation notes</h5>
          </div>
          <xm-input v-model="form_data.drop_details.notes" :placeholder="exterior_notes_placeholder" type="textarea"/>
        </div>
        <br/>
        <div>
          <div >
            <h5>Fiber installation: home interior <small>(fiber equipment mounted inside the home on an exterior wall)</small></h5>
          </div>
          <div v-for="installation_option of installationOptions" :key="installation_option.installation_type">
            <div>
              <label class="radio-head">
                <input type="radio" @click="setInstallType(installation_option)" name="install_type_radio">
                <span><b>{{ installation_option.label }}</b></span>
              </label>
              <span>${{ installation_option.billing.fees[0].rate }} ({{ installation_option.sub_description }})</span>
            </div>
            <div>
              <span>{{ installation_option.description }}</span>
            </div>
            <br/>
          </div>
          <br/>
          <div>
            <h5>Interior installation notes</h5>
          </div>
          <xm-input v-model="form_data.install_details.notes" :placeholder="interior_notes_placeholder" type="textarea"/>
        </div>
        <br/>
        <!-- Installation date selection form -->
        <Transition v-on:enter="scrolldown('strata-installation-date-details')">
          <div v-show="installTypeChosen && !querying_api" id="strata-installation-date-details">
            <div>
              <h5>Installation date and time</h5>
            </div>
            <div>
              <label>Pick an install date:</label>
              <b-form-datepicker v-model="install_date" :date-disabled-fn="dateAvailable" :initial-date="install_start_date" no-highlight-today/>
            </div>
          </div>
        </Transition>
        <br/>
        <!-- Installation time selection form -->
        <Transition v-on:enter="scrolldown('strata-installation-time-details')">
          <div v-show="installDateChosen" id="strata-installation-time-details">
            <label>Pick an install time:</label><br/>
            <b-dropdown :text="install_time">
              <b-dropdown-item v-for="installation_item of install_times" :key="installation_item.displayTime" @click="setInstallDate(installation_item)"> {{ installation_item.displayTime + ' (' + installation_item.duration + 'minutes) ' }}</b-dropdown-item>
            </b-dropdown>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>


<script>
  import req from "../../../lib/authRequest";
  import { BFormDatepicker, BDropdown, BDropdownItem } from 'bootstrap-vue';
  import TextOverlay from '../../TextOverlay';
  import SpeedSelect from '../../Signup/SpeedSelect.vue';
  import GoogleMapsDraggable from '../../Signup/GoogleMapsDraggable.vue';
  import helpers from '../../../lib/helpers';
  import XmInput from '../../XmInput.vue';
  import FormValidator from "../../FormValidator.vue";
  import reg from "../../../lib/regex";
  import ConnectivityService from '../../../lib/ssu/input_models/connectivity-service';
  import logger from "../../../lib/logger";

export default {
  data () {
    return {
      scrolldown: helpers.scrolldown,
      regex: reg,
      overlay_text: '',
      form_data: {drop_details: {latitude: '', longitude: '', notes: '', accepted: true},
                  install_details: {installation_type: '', start_datetime: '', end_datetime: '', date: '', time: 0,
                    display_time: '',  duration: 0, notes: '', external_install_id: ''}},
      service_type: 'strata-residential',
      exterior_notes_placeholder: 'Provide any details you would like the installer to know regarding the outside portion of your fiber installation.',
      interior_notes_placeholder: 'Provide any details you would like the installer to know regarding the inside portion of your fiber installation. For example, do you have internal network wiring you want the fiber connected to? Where do you want your wireless router?',
      renter_contact_form: {email: '', name: '', phone: ''},
      renter_contact_form_valid: false,
      location_details: {lat: '', lon: ''},
      install_dates: [],
      install_start_date: null,
      dates_by_date: {},
      only_dates: [],
      querying_api: false,
      install_date: null,
      install_time: 'Choose an install time',
      install_times: [],

    }
  },

  props: {
    value: {
      required: false,
      default: () => {}
    },
    // service should be an instance of ConnectivityService
    service: {
      required: true,
      type: ConnectivityService
    }
  },

  mounted () {
    this.location_details.lat = this.dropDetails.drop_latitude;
    this.location_details.lon = this.dropDetails.drop_longitude;
    this.$emit('form-state', this.serviceValid);
  },

  computed: {
    installationTypeSelected() {
      return this.form_data.install_details.installation_type !== '';
    },
    installType () {
      return this.form_data.install_details.installation_type;
    },
    installationOptions () {
      logger.debug('installation types', this.service.installationOptions());
      return this.service.installationOptions();
    },
    installTypeChosen() {
      return this.installType !== '';
    },
    installDateChosen () {
      return this.install_date !== null;
    },
    installTimeChosen () {
      return this.install_time !== 'Choose an install time';
    },
    installationRequiredDetailsValid() {
      return this.dropDetails.needs_ont_install && this.installationTypeSelected && this.installDateChosen && this.installTimeChosen;
    },
    dropDetails() {
      logger.debug('this service, strata', this.service)
      if ('address_details' in this.service) {
        return this.service.address_details;
      }
      return {}
    },
    locationDetails() {
      return this.location_details;
    },
    locationChanged(){
      return !((this.form_data.drop_details.latitude === this.dropDetails.drop_latitude) &&
               (this.form_data.drop_details.longitude === this.dropDetails.drop_longitude));
    },
    serviceValid() {
      return !this.dropDetails.needs_ont_install || this.installationRequiredDetailsValid;
    },
    serviceSubmissionData () {
      return this.form_data;
    }
  },

  methods: {
    getInstallDates () {
      this.querying_api = true;
      this.overlay_text = "Searching Available Installation Dates...";
      let self = this
      req.get({
        url: '/connectivity_clots/installation',
        params: {install_type: this.form_data.install_details.installation_type,
                 provider_id: this.service.provider.provider_id,
                 address_id: this.dropDetails.address_id},
        success(response){
          self.querying_api = false;
          self.install_start_date = response.startDate
          self.install_dates = response;
          for (let datum of response['availableTimes']) {
            if (!(datum['date'] in self.dates_by_date)) {
              self.dates_by_date[datum['date']] = [];
            }
            self.dates_by_date[datum['date']].push(datum);
          }
          self.only_dates = Object.keys(self.dates_by_date);
        },
        error(){
          self.querying_api = false;
        }
      })
    },
    setInstallType(installation_option) {
      logger.debug('installation option selected', installation_option);
      this.form_data.install_details.installation_type = installation_option.installation_type;
    },
    setInstallDate(installation_data) {
      this.install_time = installation_data.displayTime;
      this.form_data.install_details.external_install_id = installation_data.resourceId;
      this.form_data.install_details.start_datetime = installation_data.startDateTime;
      this.form_data.install_details.end_datetime = installation_data.endDateTime;
      this.form_data.install_details.date = installation_data.date;
      this.form_data.install_details.time = installation_data.time;
      this.form_data.install_details.display_time = installation_data.displayTime;
      this.form_data.install_details.duration = installation_data.duration;
    },
    dateAvailable(ymd) {
      return !this.only_dates.includes(ymd);
    },
    resetInstallForm () {
      this.install_dates = [];
      this.dates_by_date = {};
      this.only_dates = [];
      this.querying_api = false;
      this.install_date = null;
      this.install_time = 'Choose an install time';
      this.install_times = [];
    },

  },

  watch : {
    serviceValid(new_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },
    serviceSubmissionData: {
      handler(new_val) {
        new_val.drop_details.accepted = !this.locationChanged;
        this.$emit('input', new_val);
      },
      deep: true
    },
    locationDetails: {
      handler(new_val) {
        this.form_data.drop_details.latitude = new_val.lat;
        this.form_data.drop_details.longitude = new_val.lon;
      },
      deep: true
    },
    installType (new_val, old_val) {
      if (new_val !== old_val) {
        this.resetInstallForm();
        this.getInstallDates();
      }
    },
    install_date () {
      this.install_times = this.dates_by_date[this.install_date];
    },


  },

  components : {
    GoogleMapsDraggable,
    XmInput,
    FormValidator,
    SpeedSelect,
    BFormDatepicker,
    BDropdown,
    BDropdownItem,
    TextOverlay
  }

}
</script>


<style scoped>
.red-pin-icon {
  background: url('../../../assets/img/redpin-sm.png');
  height: 24px;
  width: 16px;
  display: inline-block;
  scale: 0.7;
  top: 6px;
  position: relative;
}

>>>.bg-light {
  background-color: #ddd !important;
}

>>>.disabled.rounded-circle {
  background-color: #ddd !important;
}

</style>



// WEBPACK FOOTER //
// StrataResidential.vue?82e9bf82